var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: {
            "show-error": false,
            "label-width": "100",
            "error-message-align": "right",
          },
        },
        [
          _c(
            "van-cell-group",
            _vm._l(_vm.gatherDomList, function (item, index) {
              return _vm.isShow(item.id)
                ? _c(
                    "div",
                    { key: index },
                    [
                      _c("van-field", {
                        staticClass: "fileValueBox",
                        attrs: { label: item.title, "input-align": "right" },
                        domProps: { value: _vm.formData[item.id] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "input",
                              fn: function () {
                                return [
                                  item.name === "FileUpload"
                                    ? _c("div", { staticClass: "width-100" }, [
                                        _c(
                                          "div",
                                          { staticClass: "width-100" },
                                          [
                                            _c("uploadFiles", {
                                              attrs: {
                                                disabled: _vm.isDisabled("fj"),
                                                files: _vm.formData.fj,
                                                "module-type": "flow",
                                              },
                                              on: {
                                                success: _vm.uploadSuccess,
                                                fileRemove: (removedFile) =>
                                                  _vm.handleFileRemove(
                                                    removedFile,
                                                    "formData",
                                                    "fj"
                                                  ),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  item.name === "UserPicker"
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.formData[item.id][0].name
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                  item.name !== "UserPicker"
                                    ? _c("div", [
                                        _vm.formData[item.id]
                                          ? _c("div", [
                                              item.id == "hkry"
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(_vm.userName)
                                                    ),
                                                  ])
                                                : item.name !== "FileUpload"
                                                ? _c("div", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formDataItemId(
                                                          _vm.formData,
                                                          item
                                                        ) || "无"
                                                      )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          : _c("div", [_vm._v("无")]),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e()
            }),
            0
          ),
          _vm._l(_vm.relativeFlowList, function (item, index) {
            return _vm.isShow(item.id)
              ? _c("div", { key: index }, [
                  _c(
                    "div",
                    { staticClass: "font-32 font-weight-500 cor-00 m-t-26" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formData[item.id].length > 0 ? item.title : ""
                        )
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "m-t-20" },
                    _vm._l(_vm.formData[item.id], function (ele, i) {
                      return _c(
                        "van-cell-group",
                        { key: index, staticClass: "b-r-10 m-t-20 p-20" },
                        [
                          _c(
                            "div",
                            { staticClass: "flex col-center row-between" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-1 font-30 cor-3E3A39 font-weight-600 m-l-10",
                                },
                                [_vm._v(" " + _vm._s(ele.title) + " ")]
                              ),
                            ]
                          ),
                          _c(
                            "van-row",
                            {
                              staticClass: "m-t-10",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c("van-col", { attrs: { span: "10" } }, [
                                _c("div", { staticClass: "cor-88 font-30" }, [
                                  _vm._v("流程状态"),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cor-33 font-30 van-multi-ellipsis--l3",
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(ele.businessStatusName) + " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            {
                              staticClass: "m-t-10",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c("van-col", { attrs: { span: "10" } }, [
                                _c("div", { staticClass: "cor-88 font-30" }, [
                                  _vm._v("申请时间"),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cor-33 font-30 van-multi-ellipsis--l3",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ele.startTime
                                            ? _vm
                                                .moment(ele.startTime)
                                                .format("YYYY-MM-DD HH:mm")
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            {
                              staticClass: "m-t-10",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c("van-col", { attrs: { span: "10" } }, [
                                _c("div", { staticClass: "cor-88 font-30" }, [
                                  _vm._v("完成时间"),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cor-33 font-30 van-multi-ellipsis--l3",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          ele.endTime
                                            ? _vm
                                                .moment(ele.endTime)
                                                .format("YYYY-MM-DD HH:mm")
                                            : ""
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            {
                              staticClass: "m-t-10",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c("van-col", { attrs: { span: "10" } }, [
                                _c("div", { staticClass: "cor-88 font-30" }, [
                                  _vm._v("摘要"),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _c("div", { staticClass: "cor-33 font-30" }, [
                                  _vm._v(" " + _vm._s(ele.summary) + " "),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "van-row",
                            {
                              staticClass: "m-t-10",
                              attrs: { type: "flex", align: "center" },
                            },
                            [
                              _c("van-col", { attrs: { span: "10" } }, [
                                _c("div", { staticClass: "cor-88 font-30" }, [
                                  _vm._v("事由"),
                                ]),
                              ]),
                              _c("van-col", { attrs: { span: "14" } }, [
                                _c("div", { staticClass: "cor-33 font-30" }, [
                                  _vm._v(" " + _vm._s(ele.sy) + " "),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e()
          }),
          _vm._l(_vm.independentDomList, function (item, index) {
            return _vm.isShow(item.id)
              ? _c("div", { key: index }, [
                  _c(
                    "div",
                    { staticClass: "font-32 font-weight-500 cor-00 m-t-26" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.formData[item.id].length > 0 ? item.title : ""
                        )
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "m-t-20" },
                    _vm._l(_vm.formData[item.id], function (ele, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "m-t-20" },
                        [
                          _c(
                            "van-row",
                            {
                              staticClass: "bg-FF p-b-6",
                              staticStyle: {
                                "border-bottom": "1px solid #EBEBEB",
                              },
                            },
                            [
                              _c("van-col", { attrs: { span: 11 } }, [
                                _c("img", {
                                  staticClass: "w-10 h-28",
                                  attrs: {
                                    src: `${_vm.image_base_url}/icon_line.png`,
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "cor-33 font-weight-500 font-28 m-l-16",
                                  },
                                  [_vm._v(_vm._s(`明细${i + 1}`))]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._l(
                            item.props.columns,
                            function (rowConfig, rowIndex) {
                              return _c("van-field", {
                                key: rowIndex,
                                attrs: {
                                  "input-align": "right",
                                  label: rowConfig.title,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "input",
                                      fn: function () {
                                        return [
                                          ele[rowConfig.id]
                                            ? _c("view-item", {
                                                attrs: {
                                                  value: ele[rowConfig.id] + "",
                                                  placeholder: "",
                                                },
                                              })
                                            : rowConfig.id == "summary"
                                            ? _c("div", [
                                                _c("span", [
                                                  _vm._v(
                                                    "关联单号：" +
                                                      _vm._s(ele.businessNo)
                                                  ),
                                                ]),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "借款时间：" +
                                                      _vm._s(
                                                        _vm.parseTime(
                                                          ele.debtTime,
                                                          "{y}-{m}-{d} {h}:{i}"
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "借款类型：" +
                                                      _vm._s(
                                                        _vm.getDebtType(
                                                          ele.debtType
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("br"),
                                                _c("span", [
                                                  _vm._v(
                                                    "事由：" +
                                                      _vm._s(ele.debtReason)
                                                  ),
                                                ]),
                                              ])
                                            : _c("div", [_vm._v("无")]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            }
                          ),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e()
          }),
        ],
        2
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _vm._e(),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }